export default __webpack_public_path__ + "static/media/parrot-pass.819ee53c.png";